import { useEffect, useState } from 'react'

const DEFAULT_INTERVAL = 30000

const useDataRefresh = (fetcher, hookDependencies = [], interval = DEFAULT_INTERVAL) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isRefresh, setIsRefresh] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    fetcher().then(() => setIsLoading(false))

    const intervalId = setInterval(() => {
      setIsRefresh(true)
      fetcher().then(() => setIsRefresh(false))
    }, interval)

    return () => clearInterval(intervalId)
    // eslint-disable-next-line
  }, hookDependencies)

  return [isLoading, isRefresh]
}

export default useDataRefresh
